import { render, staticRenderFns } from "./NewSectionSelector.vue?vue&type=template&id=063a5104&scoped=true&"
import script from "./NewSectionSelector.vue?vue&type=script&lang=js&"
export * from "./NewSectionSelector.vue?vue&type=script&lang=js&"
import style0 from "./NewSectionSelector.vue?vue&type=style&index=0&id=063a5104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a5104",
  null
  
)

export default component.exports